import React, {useState} from "react"
import {Alert, Button, Form, Input, message, Modal} from "antd"
import {newGrouponPlatform} from "../../../api/groupon"
import {usePlatformSettingContext} from "../store/usePlatformSettingContext"
import {PlusOutlined} from "@ant-design/icons";

const PlatformSettingAdd = () => {

    const {getPlatformList} = usePlatformSettingContext()


    const [isShow, setIsShow] = useState(false)
    const [isConfirmLoading, setIsConfirmLoading] = useState(false)
    const [form] = Form.useForm()

    const handleClick = () => {
        setIsShow(true)
        form.resetFields()
    }

    const handleFinish = async () => {
        setIsConfirmLoading(true)
        try {
            await newGrouponPlatform({
                clubId: sessionStorage.getItem('club_id'),
                name: form.getFieldValue('name')
            }).then(res => {
                if (res.status !== 1) {
                    throw new Error(res.detail)
                }
                message.success('新增成功')
                getPlatformList()
                setIsShow(false)
            })
        } catch (e) {
            message.error(`新增失败:${e.message}`)
        } finally {
            setIsConfirmLoading(false)
        }
    }

    return (
        <div>
            <Button type={"primary"} onClick={handleClick} icon={<PlusOutlined/>}>新增</Button>
            <Modal
                title={"新增团购"}
                open={isShow}
                confirmLoading={isConfirmLoading}
                onCancel={() => {
                    setIsShow(false)
                }}
                onOk={form.submit}
            >
                <Form
                    form={form}
                    onFinish={handleFinish}
                >
                    <Form.Item
                        label={"团购名称"}
                        name={"name"}
                        rules={[{required: true, message: "请输入团购名称"}]}
                    >
                        <Input placeholder="请输入团购名称"/>
                    </Form.Item>
                    <Form.Item>
                        <Alert
                            message={"注意"}
                            description={"新建的团购平台无法检验核销，仅作定时开关灯使用"}
                            type={"warning"}
                            style={{width: "100%"}}
                            showIcon
                        />

                    </Form.Item>
                </Form>
            </Modal>
        </div>
    )
}

export default PlatformSettingAdd


// WEBPACK FOOTER //
// ./src/containers/PlatformSetting/components/PlatformSettingAdd.js